import { render, staticRenderFns } from "./promote-order.vue?vue&type=template&id=4fc30440&scoped=true&"
import script from "./promote-order.vue?vue&type=script&lang=js&"
export * from "./promote-order.vue?vue&type=script&lang=js&"
import style0 from "./promote-order.vue?vue&type=style&index=0&id=4fc30440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc30440",
  null
  
)

export default component.exports